import jsEnabled from './components/jsEnabled'
import menu from './components/menu'

const ready = (callback) => {
  if (document.readyState !== 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

ready(() => {
  // Add class js, remove class no-js from html-tag
  jsEnabled()
  menu()
})
